import { render, staticRenderFns } from "./ModalRecibo.vue?vue&type=template&id=33681e92&"
import script from "./ModalRecibo.vue?vue&type=script&lang=js&"
export * from "./ModalRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports